import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutRenditionBillingList extends Layout {
	buttonProcess: Button;
	sourceRenditionBilling: DataSource;
	tableRenditionBilling: Table;
}
